/*
 * product-stock-notifier-guard.js
 * Jab customer kisi variant ka notify/preorder form submit kar deta hai,
 * wo variant browser (localStorage) me yaad rakha jata hai. Agli dafa
 * usi variant par form ki jagah thank-you message dikhta hai.
 */
(function () {
  var KEY = 'om-stock-notified';

  function getList() {
    try {
      return JSON.parse(localStorage.getItem(KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function addToList(id) {
    if (!id) return;
    try {
      var list = getList();
      if (list.indexOf(id) === -1) {
        list.push(id);
        localStorage.setItem(KEY, JSON.stringify(list));
      }
    } catch (e) {}
  }

  if (!customElements.get('product-stock-notifier-guard')) {
    customElements.define('product-stock-notifier-guard', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        this._onSubmit = function (e) {
          if (e.target && e.target.id === self.getAttribute('form-id')) {
            addToList(self.getAttribute('variant-id'));
            self._sync();
          }
        };
        document.addEventListener('submit', this._onSubmit, true);
        this._sync();
      }

      disconnectedCallback() {
        document.removeEventListener('submit', this._onSubmit, true);
      }

      _sync() {
        var submitted = getList().indexOf(this.getAttribute('variant-id')) !== -1;
        var box = this.querySelector('[data-element="notifier-box"]');
        var thanks = this.querySelector('[data-element="notifier-thanks"]');
        if (box) {
          box.toggleAttribute('hidden', submitted);
        }
        if (thanks) {
          thanks.toggleAttribute('hidden', !submitted);
        }
      }
    });
  }
})();
